import React, { createContext, useContext, useState, useEffect } from 'react';

const DataModeContext = createContext();

export const DataModeProvider = ({ children }) => {
  const [isMockMode, setIsMockMode] = useState(() => {
    const stored = localStorage.getItem('expo_data_mode');
    return stored !== null ? stored === 'mock' : false;
  });

  const toggleMode = () => {
    setIsMockMode(prev => {
      const next = !prev;
      localStorage.setItem('expo_data_mode', next ? 'mock' : 'real');
      return next;
    });
  };

  return (
    <DataModeContext.Provider value={{ isMockMode, toggleMode }}>
      {children}
    </DataModeContext.Provider>
  );
};

export const useDataMode = () => useContext(DataModeContext);

export default DataModeContext;
